var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Delete Access ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm.account
              ? _c("p", [
                  _vm._v(
                    " Are you sure you want to delete the access for “" +
                      _vm._s(_vm.accountData.email) +
                      " #" +
                      _vm._s(_vm.account) +
                      "” to “" +
                      _vm._s(_vm.serviceData.name) +
                      " #" +
                      _vm._s(_vm.service) +
                      "”? "
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [
                _vm._v(" Cancel "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v("button")]
                )
              ]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteAccess
                }
              },
              [
                _vm._v(" Delete "),
                _c(
                  "span",
                  {
                    staticClass: "visually-hidden text-lowercase"
                  },
                  [_vm._v("button")]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }